import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import eveImg from '../images/eveimg.jpg';
import eveImg2 from '../images/eveimg2.jpg';
import { FaCalendarAlt } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import { format, parseISO } from 'date-fns';
import { Player, Controls } from '@lottiefiles/react-lottie-player';

import { useNavigate } from 'react-router-dom';

export default function Events() {

  const lottiee = require('../images/lottiee.json');
  const loading = require('../images/loading.json');

  const navigate = useNavigate([]);
  const [Events, setEvents] = useState([]);
  const [loader, setloader] = useState(false);

  const eventDtl = () => {
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch("https://api.padampura.com/EventsList", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          // console.log(result)
          setEvents(result.data)
        } else {

        }
      })
      .catch((error) => console.error(error));
  }

  useEffect(() => {
    eventDtl();
    scrollToTop();
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div className='mt-3'>
      <Helmet>
  <title>News & Events | Padampura Temple</title>
  <meta name="description" content="Stay updated with the latest news and upcoming events at Padampura Temple. Spiritual discourses, festivals, and community gatherings." />
  <meta name="keywords" content="Padampura Temple Events, Jain Temple Events, Religious Events, Spiritual Gatherings, Temple News, Jain Festivals" />
  <meta name="author" content="Padampura Temple Administration" />
  <meta name="robots" content="index, follow" />

  {/* Open Graph / Social Sharing */}
  <meta property="og:title" content="News & Events - Padampura Temple" />
  <meta property="og:description" content="Explore upcoming spiritual events and news from Padampura Temple." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content={window.location.href} />
  <meta property="og:site_name" content="Padampura Temple" />
  <meta property="og:image" content="%PUBLIC_URL%/logo192.png" />
  <meta property="og:image:alt" content="Padampura Temple Logo" />

  {/* Canonical URL */}
  <link rel="canonical" href="https://padampura.com/Events" />

  {/* Structured Data (JSON-LD) */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "News & Events",
      "url": "https://padampura.com/Events",
      "description": "Official page for events and announcements at Padampura Temple.",
      "publisher": {
        "@type": "Organization",
        "name": "Padampura Temple",
        "logo": {
          "@type": "ImageObject",
          "url": "%PUBLIC_URL%/logo192.png"
        }
      }
    })}
  </script>
</Helmet>
      <div style={{ backgroundImage: `url(${eveImg2})`, width: "100%", backgroundPosition: "center", backgroundSize: "cover", objectFit: "cover", borderRadius: 5 }} >
        <div style={{ background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5), #fff 80vh)", position: "relative", height: "100%", borderRadius: 5 }} >
          <div className='container'>
            <div className='row p-5'>
              <div className='col-lg-12 col-md-8 col-sm-12 m-auto py-5'>
                <div className='card bg-transparent border-0 text-center my-5'>
                  <div class="div-content py-4">
                    <p className='' style={{ fontFamily: 'Poppins', fontSize: "3em", color: '#fff', fontWeight: 400 }} >News & Event's</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='p-5' style={{ width: '100%' }} >
        <div className='container-fluid'>
          <p className='text-center' style={{ fontFamily: "Poppins", fontSize: "2em", color: "#000", fontWeight: 600 }} >Our News & Events</p>
          <div className='row mb-4'>
            <p className='text-center col-10 m-auto' style={{ fontFamily: "Poppins", fontSize: "1em", color: "#000", fontWeight: 400 }} >Pellentesque gravida mauris . Proin dignissim orlectus, viverra elementum libero laoreet sit amet. Suspendi potenti. Ut scelerisque ultrs urna ac posuere.</p>
          </div>
          <div className='row'>
            {
              loader ? (<>
                <Player
                  autoplay
                  loop
                  src={lottiee}
                  style={{ height: '180px', width: '180px' }}
                >
                  <Controls visible={false} buttons={['play', 'repeat',]} />
                </Player>
                <div className='text-center' style={{ fontFamily: "Poppins", fontSize: 16, color: 'red' }} >Data Not Present...</div>
              </>) : Events.length == 0 ? (
                <>
                  <Player
                    autoplay
                    loop
                    src={lottiee}
                    style={{ height: '180px', width: '180px' }}
                  >
                    <Controls visible={false} buttons={['play', 'repeat',]} />
                  </Player>
                  <div className='text-center' style={{ fontFamily: "Poppins", fontSize: 16, color: 'red' }} >Please Wait...</div>
                </>
              ) : (

                Events.map((item, index) => {
                  return (
                    <div key={index} className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                      <div className='card border-0'>
                        <div style={{ backgroundImage: `url(${eveImg2})`, width: "100%", height: "100%", backgroundPosition: "center", backgroundSize: "cover", objectFit: "cover", borderRadius: 5 }} >
                          <div style={{ background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5), #ffd2a4 60vh)", position: "relative", height: "100%", borderRadius: 5 }} >
                            <div className="p-2">
                              <p className='' style={{ fontFamily: 'Poppins', fontSize: "1em", color: '#fff', fontWeight: 500 }} >{item.Ev_Name}</p>
                              <div className='d-flex justify-content-between'>
                                <div className='d-flex align-items-center justify-content-center'>
                                  <FaCalendarAlt className='me-1 text-white' style={{ fontSize: 12 }} />
                                  <div className='' style={{ fontFamily: 'Poppins', fontSize: ".7em", color: '#fff', fontWeight: 400 }} >{format(new Date(item.Ev_StartDate), 'dd/MM/yyyy')}</div>
                                </div>
                                <div className='d-flex align-items-center'>
                                  <FaLocationDot className='me-1 text-white' style={{ fontSize: 12 }} />
                                  <div className='' style={{ fontFamily: 'Poppins', fontSize: ".7em", color: '#fff', fontWeight: 400 }} >{item.address}</div>
                                </div>
                              </div>
                            </div>
                            <div className="p-3 pt-5">
                              <div className="" style={{ fontFamily: 'Poppins', fontSize: "12px", color: '#fff', fontWeight: 300, }}>{item.Ev_ShortDesc}</div>
                              <div className='row mt-3'>
                                <button onClick={() => navigate(`/EventsDetail/${item.Ev_ID}`)} className="btn-hover color-3 col-5 m-auto">View more</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              )
            }
          </div>
        </div>
      </div>
      <button className="scroll-to-top-button border-0 rounded-2" onClick={scrollToTop} style={{ width: 40, height: 40, backgroundColor: "red", color: "#fff", alignItems: "center", justifyContent: "center", display: "flex" }}><IoArrowUpCircleOutline style={{ fontSize: 40 }} /></button>
    </div>
  )
}
